export type LeagueId = 'bronze' | 'silver' | 'gold' | 'diamond' | 'archon';

export interface LeagueDef {
  id: LeagueId;
  name: string;
  icon: string;
  color: string;
  percentileMin: number; // top X% qualifies (0 = best)
  percentileMax: number;
  gemsReward: number;
}

export interface SeasonData {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  active: boolean;
}

export const LEAGUES: readonly LeagueDef[] = [
  { id: 'archon', name: 'Archon', icon: '👑', color: '#c9a44c', percentileMin: 0, percentileMax: 5, gemsReward: 100 },
  { id: 'diamond', name: 'Diamond', icon: '💎', color: '#a855f7', percentileMin: 5, percentileMax: 20, gemsReward: 50 },
  { id: 'gold', name: 'Gold', icon: '🥇', color: '#ffd700', percentileMin: 20, percentileMax: 50, gemsReward: 25 },
  { id: 'silver', name: 'Silver', icon: '🥈', color: '#c0c0c0', percentileMin: 50, percentileMax: 80, gemsReward: 10 },
  { id: 'bronze', name: 'Bronze', icon: '🥉', color: '#cd7f32', percentileMin: 80, percentileMax: 100, gemsReward: 5 },
];

export const SEASON_DURATION_WEEKS = 4;

export function getLeagueForPercentile(percentile: number): LeagueDef {
  for (const league of LEAGUES) {
    if (percentile >= league.percentileMin && percentile < league.percentileMax) {
      return league;
    }
  }
  return LEAGUES[LEAGUES.length - 1]!; // bronze fallback
}
